import { createSlice } from "@reduxjs/toolkit";

const date = new Date(); // Define date here
const optionsDate = { day: "2-digit", month: "2-digit", year: "numeric" };
const optionsTime = { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true };

const formattedDate = date.toLocaleDateString("en-GB", optionsDate);
const formattedTime = date.toLocaleTimeString("en-US", optionsTime);
const currentYear = date.getFullYear();

const detailsToSendSlice = createSlice({
  name: "detailsToSend",
  initialState: {
    details: {}, // Initialize as an empty object
    academicYear: currentYear,
    transactionTime: formattedTime,
    transactionDate: formattedDate,
  },
  reducers: {
  setDetailsToSend: (state, action) => {
    state.details = action.payload
  },
  clearDetailsToSend: (state) => {
    state.details = {}; 
  },
clearBillerLogo: (state) => {
  const { billerLogo, ...rest } = state.details;
  state.details = rest;
}
}

});

export const { setDetailsToSend, clearDetailsToSend, clearBillerLogo } = detailsToSendSlice.actions;

export default detailsToSendSlice.reducer;
